export const NOT_FOUND_PATH: string = '/'; // FIXME: Create a 404 page
const MODE = process.env.NEXT_PUBLIC_MODE; // ← 改名
const ORIGIN = typeof window !== 'undefined' ? window.location.origin : ''; // http/https 自動帶上

export const CS_BASE_URL = MODE === 'local' ? 'http://localhost:8081/search' : `${ORIGIN}/search`;

export const NEW_CS_BASE_URL = MODE === 'local' ? 'http://localhost:8081' : ORIGIN;

export const INTELLIDATA_BASE_URL = process.env.NEXT_PUBLIC_INTELLIDATAURL; // ← 改名

export const linkPrefix = MODE === 'local' ? 'https://yageogroup.com' : NEW_CS_BASE_URL;
